import { render } from "./FinancialWelfare.vue?vue&type=template&id=4fca21a6&scoped=true&ts=true"
import script from "./FinancialWelfare.vue?vue&type=script&lang=ts"
export * from "./FinancialWelfare.vue?vue&type=script&lang=ts"

import "./FinancialWelfare.vue?vue&type=style&index=0&id=4fca21a6&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fca21a6"]])

export default __exports__